import BaseStore from 'hljd/esm/SearchBar/store'
import Api from '@api/experienceShop'
import { observable } from 'mobx'
import { getExportUrl } from '@util'

class Store extends BaseStore {
  $listApi = Api.monthFlows
  @observable listData = {}

  $getParams = () => {
    return {
      ...this.$params
    }
  }

  $extraOp = data => {
    this.listData = data
  }

  exportList = () => {
    const url = getExportUrl(
      '/p/wedding/Admin/APICrmBrokerage/exportMonthFlows',
      this.$getParams()
    )
    window.open(url)
  }
}

export default Store
